<template>
  <div class="h-100">
    <div
      class="row mb-3"
      v-if="
        (resultsList && resultsList.length) ||
        (!resultsList.length && isFilterSelected) ||
        (!isLoaded &&
          ((resultsList && resultsList.length) || isFilterSelected)) ||
        (!isLoaded && isFilterSelected && !resultsList.length)
      "
    >
      <div class="col-md-12">
        <form action="" @submit.prevent class="h-100">
          <ValidationObserver ref="form" v-slot="{}">
            <div class="row d-flex justify-content-between">
              <div class="col-md-4">
                <div class="form-group mb-2">
                  <validation-provider
                    name="recherche"
                    rules="min:3"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      name="search"
                      v-model.trim="q"
                      v-debounce:1s.fireonempty="search"
                      class="form-control form-control_search"
                      :placeholder="$t('buttons.searchByName')"
                      :class="{ 'is-invalid': errors.length }"
                      @input="isLoaded = false"
                    />
                    <span class="text-danger small">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="col-md-4 d-flex justify-content-end">
                <div>
                  <button
                    class="btn btn-icon ml-4"
                    :class="
                      (selectedFilterItems && selectedFilterItems.length) ||
                      statusFilter
                        ? 'btn-dark'
                        : 'btn-filter '
                    "
                    type="button"
                    @click.prevent.stop="showFilterModal"
                  >
                    <span
                      :class="
                        (selectedFilterItems && selectedFilterItems.length) ||
                        statusFilter
                          ? 'icon icon-filter-light'
                          : 'icon icon-filter'
                      "
                    />
                    <span class="">
                      {{ $t('filter') }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </form>
      </div>
    </div>
    <div class="row mb-4" v-if="resultsList && resultsList.length">
      <div class="col-md-12">
        <div>
          <button
            class="btn btn-icon btn-toggle mb-2"
            :class="isFilteredListSelected ? 'btn-white' : 'btn-filter-toggle'"
            @click.stop.prevent="toggleSelectedFiltered"
            :disabled="isAllResultsSelected || !isFilterSelected"
          >
            <span
              class="icon"
              :class="isFilteredListSelected ? 'icon-check' : 'icon-check-gray'"
            />
            {{ $t('selectFiltered') }} ({{ filtredResults.length }})
          </button>

          <button
            class="btn btn-icon btn-toggle mb-2"
            :class="isAllResultsSelected ? 'btn-white' : 'btn-filter-toggle'"
            @click.stop.prevent="toggleSelectAllResults"
          >
            <span
              :class="
                isAllResultsSelected
                  ? 'icon icon-trainee'
                  : 'icon icon-trainee-gray'
              "
            />
            {{
              $tc(
                isAllResultsSelected ? 'deselectAll' : 'selectAll',
                pagination.total
              )
            }}
          </button>
        </div>
        <div v-if="false">
          <button
            @click.stop.prevent="unsubscribe"
            :class="{ disabled: !isSelected }"
            class="btn btn-primary btn-icon mb-2"
          >
            <span class="icon icon-file_white"></span>
            {{ $tc('reRegiste', isSelected) }}
          </button>
        </div>
        <!--<button
          @click.stop.prevent="deletedResults"
          :class="{ disabled: !isSelected }"
          class="btn btn-primary btn-icon mb-2"
        >
          <span class="icon icon-file_white"></span>
          {{ $tc('deletedResults', isSelected) }}
        </button>-->
      </div>
    </div>
    <div class="row h-100">
      <div class="col-md-12">
        <div v-if="isLoaded">
          <div
            class="legend mb-3"
            v-if="
              (resultsList && resultsList.length) ||
              (!resultsList.length && isFilterSelected) ||
              (!isLoaded &&
                ((resultsList && resultsList.length) || isFilterSelected)) ||
              (!isLoaded && isFilterSelected && !resultsList.length)
            "
          >
            <div class="legend__items">
              <div class="legend__header">
                {{ $t('legend') }}
              </div>

              <a
                href="#"
                @click.prevent.stop="filterByStatus(3)"
                :class="
                  statusFilter == 3 ? 'legend__item-filtrable-active' : ''
                "
                class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
              >
                <div class="icon icon-success-badge"></div>
                <div>{{ $t('SucceededStatus') }}</div>
              </a>

              <a
                href="#"
                @click.prevent.stop="filterByStatus(2)"
                :class="
                  statusFilter == 2 ? 'legend__item-filtrable-active' : ''
                "
                class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
              >
                <div class="icon icon-fail-badge"></div>
                <div>{{ $t('FailedStatus') }}</div>
              </a>

              <a
                href="#"
                @click.prevent.stop="filterByStatus(1)"
                :class="
                  statusFilter == 1 ? 'legend__item-filtrable-active' : ''
                "
                class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
              >
                <div class="icon icon-not-started"></div>
                <div>{{ $t('certificatePending') }}</div>
              </a>
            </div>
            <div>
              <div class="d-flex justify-content-end" v-if="isFilterSelected">
                <button
                  class="btn btn-reset-filter btn-icon px-0"
                  @click="resetFilter"
                >
                  {{ $t('resetFilter') }}
                </button>
              </div>
            </div>
          </div>
          <div
            v-cloak
            class="dates dates_users"
            v-if="resultsList && resultsList.length"
          >
            <table
              class="table profile-table table-responsive-lg overflow-y-xs text-left"
            >
              <th></th>

              <th>{{ $t('id') }}</th>
              <th>{{ $t('form.name') }}</th>
              <th>{{ $t('courseLanguage') }}</th>
              <th>{{ $t('training') }}</th>
              <th>{{ $t('RegistrationDate') }}</th>
              <th>{{ $t('form.status') }}</th>
              <tbody class="box-block">
                <result-row
                  v-for="(result, index) in resultsList"
                  :key="result.resultID"
                  :index="index"
                  :result="result"
                  :user="user"
                ></result-row>
              </tbody>
            </table>
            <div class="row mt-3 mb-3" v-if="totalPages > 1">
              <div class="col-sm-12 d-flex justify-content-between">
                <div class="">
                  <button
                    class="btn btn-filter btn-icon"
                    @click="previousPage()"
                  >
                    <span class="icon icon-arrow-left" /> {{ $t('previous') }}
                  </button>
                </div>
                <div>{{ $t('pagination', [page, totalPages]) }}</div>
                <div class="">
                  <button class="btn btn-filter btn-icon" @click="nextPage()">
                    {{ $t('next') }} <span class="icon icon-arrow-right" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div
              class="box-block text-center"
              v-cloak
              v-if="!resultsList.length && isFilterSelected"
            >
              <div class="alert alert-primary mb-0">
                {{ $t('emptyFiltredResultsList') }}
              </div>
            </div>
            <div
              class="box-block text-center"
              v-cloak
              v-else-if="!resultsList.length"
            >
              <div class="alert alert-primary mb-0">
                {{ $t('team.emptyResultList') }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <div
            class="h-100 row d-flex justify-content-center align-items-center"
          >
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FilterModal />
    <confirmation-modal></confirmation-modal>
  </div>
</template>

<script>
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import ResultRow from './ResultRow.vue'
import FilterModal from './FilterModal.vue'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'Results',
  components: {
    ConfirmationModal,
    ResultRow,
    FilterModal,
  },
  data() {
    return {
      page: 1,
      q: '',
      resultsList: [],
      selectedFilterItems: [],
      lastTrimedQuery: '',
      isFiltred: false,
      form: {
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        gender: 0,
      },
      isLoaded: false,
      filterData: {
        startDate: null,
        endDate: null,
        languge: null,
        training: null,
        status: null,
      },
      queryPayload: {},
      statusFilter: null,
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'establishment', 'company']),
    ...mapFields([
      'results.results',
      'results.pagination',
      'results.selectedResults',
      'results.filtredResults',
      'results.isFilteredListSelected',
      'results.isAllResultsSelected',
      'results.limit',
    ]),
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
    totalPages() {
      return this.$lodash.get(this.pagination, 'total_pages', 1)
    },
    isSelected() {
      if (this.isAllResultsSelected) {
        return this.pagination.total
      } else return this.selectedResults.length
    },
    isFilterSelected() {
      if (
        this.statusFilter ||
        this.q ||
        (this.selectedFilterItems && this.selectedFilterItems.length)
      ) {
        return true
      } else return false
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) this.page = 1
    },
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          console.log('this.$route.query ', this.$route.query)
          let payload = {
            params: {
              page: this.page,
              limit: this.limit,
              ...this.$route.query,
            },
          }

          this.filter(payload.params)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.filtredResults = []
    this.selectedFilterItems = []
    this.isFilteredListSelected = false
    this.isFiltred = false
    this.lastTrimedQuery = ''
    this.queryPayload = {
      ...{ page: 1, limit: this.limit },
    }
    this.$bus.$on('results-filter', (data) => {
      this.selectedFilterItems = data.filterData
      let params = data.data
      if (this.q) {
        params = {
          ...params,
          action: 'search',
          q: this.q,
        }
      }
      let payload = {
        params,
        id: this.user.id,
      }
      console.log('payload ', payload)

      this.queryPayload = payload.params
      this.$router
        .replace({ query: this.queryPayload })
        .then(() => {
          if (this.isAllResultsSelected) {
            this.selectedResults = []
            this.$lodash.forEach(this.resultsList, (result) => {
              this.selectedResults.push(result.registrationId)
            })
          }
          if (this.isFilteredListSelected && this.isFilterSelected) {
            this.selectedResults = []
            this.$lodash.forEach(this.resultsList, (result) => {
              this.selectedResults.push(result.registrationId)
            })
          }
          this.filterData.startDate = params?.startDate ?? ''
          this.filterData.endDate = params?.endDate ?? ''
          this.filterData.languge = params?.languge ?? ''
          this.filterData.training = params?.training ?? ''
          this.filterData.status = params?.status ?? null
          this.statusFilter = params?.status ?? null
        })
        .catch((error) => {})
        .finally(() => {
          this.$bus.$emit('hide-filter-results-modal')
        })
    })
  },

  methods: {
    resetFilter() {
      this.q = ''
      this.lastTrimedQuery = ''
      this.statusFilter = 0
      this.filterData.startDate = null
      this.filterData.endDate = null
      this.filterData.languge = null
      this.filterData.training = null
      this.filterData.status = null
      this.queryPayload = {
        ...{ page: 1, limit: this.limit },
      }
      this.selectedFilterItems = []
      this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      this.$bus.$emit('reset-results-filter')
    },
    showFilterModal() {
      this.$bus.$emit('filter-results-modal.show', {
        statusFilter: this.statusFilter,
      })
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...{
            startDate: this.filterData?.startDate ?? null,
            endDate: this.filterData?.endDate ?? null,
            languge: this.filterData?.languge ?? null,
            training: this.filterData?.training ?? null,
            status: this.filterData?.status ?? null,
          },
        }
        console.log('a  = ', a)
        this.$router.push({ name: 'Results', query: a }).catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        this.page--
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...{
            // startDate: this.filterData?.startDate ?? null,
            // endDate: this.filterData?.endDate ?? null,
            // languge: this.filterData?.languge ?? null,
            // training: this.filterData?.training ?? null,
            status: this.filterData?.status ?? null,
          },
        }
        this.$router.replace({ query: a }).catch((error) => {})
      }
    },
    search() {
      if (this.q != '') {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (this.lastTrimedQuery == qString.trim()) {
          return
        }
        if (qString.length < 2) return
        this.isLoaded = false
        this.page = 1
        let payload = {
          params: {
            action: 'search',
            q: qString,
            ...{ page: this.page, limit: this.limit },
            ...this.filterData,
          },
          id: this.user.id,
        }
        this.lastTrimedQuery = qString.trim()
        this.queryPayload = payload.params

        this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      } else {
        this.page = 1
        this.queryPayload = {
          ...{ page: 1, limit: this.limit },
          ...this.filterData,
          q: '',
        }
        console.log('this.queryPayload')
        this.lastTrimedQuery = ''
        this.$router
          .replace({ query: this.queryPayload })
          .then(() => {
            this.filtredResults = []
          })
          .catch((error) => {})
      }
    },
    filterByStatus(status) {
      this.filterData.status = status
      this.page = 1
      let data = {
        ...this.$route.query,
        ...{ page: 1, limit: this.limit },
        ...this.filterData,
      }
      if (this.q != '') {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (qString.length < 2) return
        data = { ...data, action: 'search', q: qString }
      }
      this.filterData.status = status
      this.statusFilter = status
      let payload = {
        params: {
          ...data,
        },
        id: this.user.id,
      }
      this.queryPayload = payload.params
      // this.filter(payload)
      this.$router.replace({ query: this.queryPayload }).catch((error) => {})
    },
    filter(params) {
      console.log('params ', params)
      this.isLoaded = false

      return this.$store
        .dispatch('results/getResultsByClientId', params)
        .then(() => {
          this.resultsList = this.results ?? []
          this.filtredResults = this.results ?? []
          console.log('this.isAllResultsSelected ', this.isAllResultsSelected)
          if (
            this.isAllResultsSelected ||
            (this.isFilteredListSelected && this.isFilterSelected)
          ) {
            this.selectedResults = []
            this.$lodash.forEach(this.results, (result) => {
              this.selectedResults.push(result.resultID)
            })
            console.log('this.selectedResults ', this.selectedResults)
          }
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    getResults(params) {
      this.isLoaded = false
      this.$store
        .dispatch('results/getResultsByClientId', params)
        .then(() => {
          console.log(this.results)
          this.resultsList = this.results ?? []
          if (
            this.isAllResultsSelected ||
            (this.isFilteredListSelected && this.isFilterSelected)
          ) {
            this.selectedResults = []
            this.$lodash.forEach(this.resultsList, (result) => {
              this.selectedResults.push(result.registrationId)
            })
          }
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    toggleSelectedFiltered() {
      this.isFilteredListSelected = !this.isFilteredListSelected
      this.isAllResultsSelected = false
      this.selectedResults = []
      if (this.isFilteredListSelected) {
        this.$lodash.forEach(this.filtredResults, (result) => {
          this.selectedResults.push(result.resultID)
        })
      }
    },
    toggleSelectAllResults() {
      this.isAllResultsSelected = !this.isAllResultsSelected
      this.isFilteredListSelected = false
      this.selectedResults = []

      if (this.isAllResultsSelected) {
        this.$lodash.forEach(this.results, (result) => {
          this.selectedResults.push(result.resultID)
        })
      }
    },
    unsubscribe() {
      this.isLoaded = false
      const data = {
        companyId: this.company.id,
        resultIds: this.selectedResults,
      }
      this.$store
        .dispatch('results/deleteRegistration', data)
        .then((response) => {
          let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
          this.getResults(a)
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    deletedResults() {
      this.isLoaded = false
      const data = {
        resultIds: this.selectedResults,
      }
      this.$store
        .dispatch('results/deleteResults', data)
        .then((response) => {
          let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
          this.getResults(a)
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.legend {
  justify-content: space-between;
}
</style>
